export default "__VITE_PUBLIC_ASSET__691491b6__"